"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Modal = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Modal"));
var _reactRedux = require("react-redux");
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/domains/assets");
var _ModalHeader = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalHeader"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _events = require("../../analytics/events");
var _modals = require("../../utils/modals");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "modal": "VersionsTableModal__modal__1B3pT",
  "header": "VersionsTableModal__header__2-NCU",
  "body": "VersionsTableModal__body__vcbL-",
  "footer": "VersionsTableModal__footer__1msMc",
  "title": "VersionsTableModal__title__3LQFC",
  "modal-lg": "VersionsTableModal__modal-lg__2_xO7",
  "modalLg": "VersionsTableModal__modal-lg__2_xO7"
}; 
require('./VersionsTableModal.css');
var AssetPortalVersionsTable = function AssetPortalVersionsTable(props) {
  var VersionsTable = (0, _exchangeReactHooks.useVersionsTable)();
  return /*#__PURE__*/_react.default.createElement(VersionsTable, props);
};
var VersionsTableModal = function VersionsTableModal(_ref) {
  var asset = _ref.asset,
    className = _ref.className,
    theme = _ref.theme;
  var labelId = 'asset-versions-modal-title';
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isAllowedCloseModal = _useState2[0],
    setIsAllowedCloseModal = _useState2[1];
  var _useModals = (0, _exchangeReactHooks.useModals)(),
    closeModal = _useModals.closeModal;
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var isDraft = (0, _exchangeReactHooks.useIsPortalDraft)();
  var isEdit = (0, _exchangeReactHooks.useIsPortalEdit)();
  var canEdit = (0, _reactRedux.useSelector)(function (state) {
    return _assets.selectors.canShowEdition(state, asset);
  });
  var onAddNewVersion = function onAddNewVersion($asset) {
    trackEvent(_events.EVENT_TYPES.NEW_VERSION_ADDED, (0, _events.assetProperties)({
      asset: $asset
    }));
    closeModal();
  };
  var allowCloseModal = function allowCloseModal() {
    setIsAllowedCloseModal(true);
  };
  var disallowCloseModal = function disallowCloseModal() {
    setIsAllowedCloseModal(false);
  };
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    renderInBody: false,
    testId: "asset-versions-modal",
    onEsc: function onEsc() {
      if (isAllowedCloseModal) {
        closeModal();
      }
    },
    onClickOverlay: function onClickOverlay() {
      return closeModal();
    },
    className: (0, _classnames.default)(styles.modal, styles.modalLg, className),
    ariaLabelledBy: labelId,
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
    className: styles.header,
    testId: "asset-versions-header",
    onClose: function onClose() {
      return closeModal();
    }
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: styles.title,
    id: labelId,
    "data-test-id": "asset-versions-title"
  }, "Patch versions for ", asset.minorVersion)), /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
    testId: "asset-versions-body",
    className: styles.body
  }, /*#__PURE__*/_react.default.createElement(AssetPortalVersionsTable, {
    asset: asset,
    isDraft: isDraft,
    isEdit: isEdit,
    canEdit: canEdit,
    useOpenModal: false,
    onAddNewVersion: onAddNewVersion,
    onClose: allowCloseModal,
    onOpen: disallowCloseModal
  })), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
    testId: "asset-versions-footer",
    className: styles.footer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: "asset-versions-close-button",
    kind: "tertiary",
    onClick: function onClick() {
      return closeModal();
    },
    noFill: true
  }, "Close")));
};
var VersionsTableModalContainer = (0, _modals.setModalName)('VersionsTableModal')(VersionsTableModal);
var _default = exports.default = VersionsTableModalContainer;
//# sourceMappingURL=VersionsTableModal.js.map